import React from "react";
import Modal from "react-bootstrap/Modal";
//UI
import { Input, Select, Textarea } from "../../../../ui/inputs/Input";
import { DangerButton, SuccessButton } from "../../../../ui/buttons/Button";

export default function Persona({ show, setShow, setTabla }) {
  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  return (
    <Modal size="lg" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Desbloquear Registros</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap">
        <div className="col-12 m-0 mb-2 p-0">
          <div className="col-3 m-0 p-0">
            <Input label = 'Cedula:' />
          </div>
        </div>
        <div className="col-6 m-0 mb-2 p-0">
          <Input label = 'Nombres:' />
        </div>
        <div className="col-6 m-0 mb-2 p-0 pl-2">
          <Input label = 'Apellidos:' />
        </div>
        <div className="col-12 m-0 mb-2 p-0">
          <Textarea label = 'Dirección:' style = {{ height: 70 }} />
        </div>
        <div className="col-4 m-0 mb-2 p-0">
          <Input label = 'Correo Electrónico:' />
        </div>
        <div className="col-4 m-0 mb-2 p-0 pl-2">
          <Input label = 'Teléfono:' />
        </div>
        <div className="col-4 m-0 mb-2 p-0 pl-2">
          <Input label = 'Celular:' />
        </div>
        <div className="col-4 m-0 p-0">
          <Input label = 'Fecha de Nacimiento:' type = 'date' />
        </div>
        <div className="col-3 m-0 p-0 pl-2">
          <Select label = 'Nacionalidad:' ></Select>
        </div>
        <div className="col-2 m-0 p-0 pl-2">
          <Select label = 'Sexo:' ></Select>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton>Aceptar</SuccessButton>
        <DangerButton>Cancelar</DangerButton>
      </Modal.Footer>
    </Modal>
  );
}
